import * as React from 'react';

function SvgChatboxEllipsesOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { stroke: "currentColor", strokeLinejoin: "round", strokeWidth: 1.6, d: "M19.308 3H4.692A2.7 2.7 0 002 5.692v9.231a2.7 2.7 0 002.692 2.692h1.923v3.847l4.506-3.757a.384.384 0 01.247-.09h7.94A2.7 2.7 0 0022 14.923v-9.23A2.7 2.7 0 0019.308 3v0z" }),
        React.createElement("path", { fill: "currentColor", d: "M7.384 11.847a1.538 1.538 0 100-3.077 1.538 1.538 0 000 3.077zM12 11.847a1.538 1.538 0 100-3.077 1.538 1.538 0 000 3.077zM16.616 11.847a1.538 1.538 0 100-3.077 1.538 1.538 0 000 3.077z" })));
}

export default SvgChatboxEllipsesOutline;
